import { formatPriceAmount } from "../../../../utils/numbers"
import { CurrencyImage } from "../../../tables/transactions-table/columns/currencyImageCell"
import {
	InboundArs,
	InboundCrypto,
	taxNames,
} from "../../../tables/transactions-table/data/types"
import { Heading2, Heading6 } from "../../../ui/texts/TextStyle"
import BodyBlock from "../../payment-modal/body/BodyBlock"
import BodyItem from "../../payment-modal/body/BodyItem"
import TaxesAccordion from "../../payment-modal/body/TaxesAccordion"

const InboundTransactionModalBody = ({
	transaction,
}: {
	transaction: InboundArs | InboundCrypto
}) => {
	switch (transaction.movement_type) {
		case "transfer":
			const sender = transaction.sender
			const recipient = transaction.recipient
			console.log("MODAL INBOUND TRANS", transaction)
			const comm_str =
				transaction.commission && transaction.commission.percent
					? `(${transaction.commission.percent.toFixed(2)}%)`
					: ""
			return (
				<div className="grid grid-cols-1 items-center">
					<BodyBlock title={"Resumen transferencia"}>
						<BodyItem
							name="Hora"
							value={transaction.time.formatted.time}
							overflow={true}
						/>

						<BodyItem
							name="Fecha"
							value={transaction.time.formatted.date}
							overflow={true}
						/>
						<BodyItem
							name="Monto recibido"
							value={`${transaction.amountReceived} ${transaction.currency}`}
						/>
						{transaction.commission && transaction.commission.commission && (
							<BodyItem
								name={`Comisión ${comm_str}`}
								value={`-${formatPriceAmount(
									transaction.commission.commission.amount,
									undefined,
									transaction.commission.commission.currency
								)} ${transaction.commission.commission.currency}`}
							/>
						)}
						{transaction.commission.commissionTaxes && transaction.commission?.commissionTaxes?.map((tax) => {
							return (
								<BodyItem
									key={tax.tax_type}
									name={`${taxNames[tax.tax_type]} ${tax.tax_rate}%`}
									value={`-${formatPriceAmount(tax.tax_amount)} ARS`}
								/>
							)
						})}
						{transaction.taxes && <TaxesAccordion tx={transaction} />}

						<div className="flex justify-between items-center py-betweenComponents">
							<Heading6 className="font-medium text-text-muted">
								Acreditado
							</Heading6>
							{transaction.amountCredited && (
								<div className="flex-col  mb-2 whitespace-nowrap ">
									<div className="flex justify-end">
										<CurrencyImage currency={transaction.currency} />

										<Heading2 className="ml-betweenTexts font-medium whitespace-nowrap">
											{formatPriceAmount(
												transaction.amountCredited,
												undefined,
												transaction.currency
											)}
										</Heading2>

										<Heading2 className="ml-betweenTexts font-light">
											{transaction.currency}
										</Heading2>
									</div>
								</div>
							)}
						</div>

						{transaction.store_name && (
							<BodyItem name="Tienda" value={transaction.store_name} />
						)}

						{transaction.orderId && (
							<BodyItem name="Nro de orden" value={transaction.orderId} />
						)}
					</BodyBlock>

					{recipient &&
						(recipient.alias ||
							recipient.bank_entity?.name ||
							recipient.cvu) && (
							<BodyBlock title={"Destino"}>
								{recipient.alias && (
									<BodyItem name="Alias" value={recipient.alias} />
								)}

								{recipient.cvu && (
									<BodyItem
										name="CVU"
										value={recipient.cvu}
										copy={true}
										overflow={true}
									/>
								)}
								{recipient.bank_entity?.name && (
									<BodyItem name="Banco" value={recipient.bank_entity?.name} />
								)}
							</BodyBlock>
						)}
					{sender && (
						<BodyBlock title={"Datos del cliente"}>
							{sender.titular && (
								<BodyItem name="Nombre" value={sender.titular} copy={true} />
							)}
							{sender.bank_entity?.name && (
								<BodyItem name="Banco" value={sender.bank_entity?.name} />
							)}

							{sender.cuit && <BodyItem name="CUIT" value={sender.cuit} />}
							{sender.cvu && (
								<BodyItem
									name="CVU"
									value={sender.cvu}
									copy={true}
									overflow={true}
								/>
							)}
						</BodyBlock>
					)}
				</div>
			)
		case "crypto":
			var comm_str_cryto =
				transaction.commission && typeof transaction.commission === "number"
					? `(${transaction.commission.toFixed(2)}% + IVA)`
					: `(${transaction.commission}% + IVA)`
			return (
				<div className="grid grid-cols-1 items-center">
					<BodyBlock title={"Resumen"}>
						<BodyItem
							name="Hora"
							value={transaction.time.formatted.time}
							overflow={true}
						/>

						<BodyItem
							name="Fecha"
							value={transaction.time.formatted.date}
							overflow={true}
						/>
						<BodyItem
							name="Monto recibido"
							value={`${transaction.amountReceived} ${transaction.currency}`}
						/>
						{transaction.amountCommission && (
							<BodyItem
								name={`Comisión ${comm_str_cryto}`}
								value={`-${formatPriceAmount(
									transaction.amountCommission,
									undefined,
									transaction.currency
								)} ${transaction.currency}`}
							/>
						)}

						<div className="flex justify-between items-center py-betweenComponents">
							<Heading6 className="font-medium text-text-muted">
								Acreditado
							</Heading6>
							{transaction.amountCredited && (
								<div className="flex-col  mb-2 whitespace-nowrap ">
									<div className="flex justify-end">
										<CurrencyImage currency={transaction.currency} />

										<Heading2 className="ml-betweenTexts font-medium whitespace-nowrap">
											{formatPriceAmount(
												transaction.amountCredited,
												undefined,
												transaction.currency
											)}
										</Heading2>

										<Heading2 className="ml-betweenTexts font-light">
											{transaction.currency}
										</Heading2>
									</div>
								</div>
							)}
						</div>

						{transaction.store_name && (
							<BodyItem name="Tienda" value={transaction.store_name} />
						)}

						{transaction.orderId && (
							<BodyItem name="Nro de orden" value={transaction.orderId} />
						)}
					</BodyBlock>

					<BodyBlock title={"Destino"}>
						{transaction.recipient.address && (
							<BodyItem
								name="Dirección"
								value={transaction.recipient.address}
							/>
						)}
					</BodyBlock>
					<BodyBlock title={"Datos del cliente"}>
						{transaction.sender.address && (
							<BodyItem name="Dirección" value={transaction.sender.address} />
						)}
					</BodyBlock>
				</div>
			)
		default:
			break
	}
}
export default InboundTransactionModalBody
